import React, { useState, useEffect, useRef } from "react";

import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import "./dragAndDrop.css";

function DragDropInput({
  label = "Arraste e solte um arquivo ou clique aqui",
  icon = <CloudUploadIcon className="icon-cloud" />,
  handleFile,
  typesAccept = "image/png, image/jpeg, image/jpg",
  multiple = false,
}) {
  const [dragging, setDragging] = useState(false);
  const dropRef = useRef(null);
  let dragCounter = 0;

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragging(true);
    }
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter--;
    if (dragCounter > 0) return;
    setDragging(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files);
      e.dataTransfer.clearData();
      dragCounter = 0;
    }
  };

  const handleSelectImage = (e) => {
    if (!e.target.files[0]) return;

    handleFile(e.target.files);
  };

  useEffect(() => {
    // eslint-disable-next-line
    dragCounter = 0;
    let div = dropRef.current;
    div.addEventListener("dragenter", handleDragIn);
    div.addEventListener("dragleave", handleDragOut);
    div.addEventListener("dragover", handleDrag);
    div.addEventListener("drop", handleDrop);
  }, []);

  return (
    <div className="container-drag-drop" ref={dropRef}>
      <div>
        {dragging ? (
          <div className="dragging">
            <label>Solte aqui</label>
          </div>
        ) : (
          <div className="no-dragging">
            <label>
              <input
                className="input-file"
                accept={typesAccept}
                type="file"
                name="logomarca"
                onChange={handleSelectImage}
                value=""
                multiple={multiple}
              />
              {label}
              <div>{icon}</div>
            </label>
          </div>
        )}
      </div>
    </div>
  );
}

export default DragDropInput;
